import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutTieredStopPayList extends Layout {
    layoutheaderTitle: LayoutHeader;
    sourceTieredStop: DataSource;
    tableTieredStopPay: Table;
}
